import script from "./CombineRollbackForm.vue?vue&type=script&setup=true&lang=ts"
export * from "./CombineRollbackForm.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__